import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSnapshot } from "valtio";
import Authentication from "../PageComponent/Authentication/Authentication";
import {
  initZoho,
  fetchOrgVariablesData,
  handleAuthCheckZoho,
  handleAuthenticateZoho,
} from "../util/zohoUtil";
import ModuleSetting from "../PageComponent/ModuleSetting/ModuleSetting";
import RelatedList from "../PageComponent/RelatedList/RelatedList";
import logo from "../Images/easypluginz-label.png";
import ShowError from "../atoms/ShowError";
import SnackAlert from "../atoms/SnackAlert";
import { getCloseSnakData, snackDetails, views } from "../config/otherConstant";
import ModuleDefaultSetting from "../Components/SettingsPage/ModuleDefaultSetting/ModuleDefaultSetting";
import ModulesRelatedFieldSetting from "../Components/ModuleRelatedSetting/ModulesRelatedFieldSetting";
import { widState } from "../Store/workdriveState";
import Loader from "../Components/Overview/Loader";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function SettingsRoute() {
  const widSnap = useSnapshot(widState);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [auth, setAuth] = useState(false);
  const [hideLogo, setHideLogo] = useState(false);
  const [orgId, setOrgId] = useState(null);
  const [connName, setConnName] = useState(null);
  const [users, setUsers] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [useLoginUserCredential, setUseLoginUserCredential] = useState(null);
  const [authenticatedUserMap, setAuthenticatedUserMap] = useState({});
  const [defaultAuthenticator, setDefaultAuthenticator] = useState(null);
  const [zuid, setZuid] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [zApiKey, setZApiKey] = useState(null);
  const [dataCenterUrl, setDataCenterUrl] = useState(null);
  const [dataCenter, setDataCenter] = useState(null);
  const [serviceApiKey, setServiceApiKey] = useState(null);
  const [zohoLoaded, setZohoLoaded] = useState(false);
  const [view, setView] = useState(null);
  const [pageSize, setPageSize] = useState(null);

  const [snack, setSnack] = useState(snackDetails);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack((prev) => getCloseSnakData(prev));
    // setOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    initZoho((error, extensionData) => {
      if (error || !extensionData) {
        // Set Loading false
        setLoading((prev) => false);
        // Set Error Message
        return;
      }
      const {
        serviceAuth,
        orgId,
        apiKey,
        dataCenterUrl,
        zohoLoaded,
        zohoAuth,
        serviceApiKey,
        zuid,
        zApiKey,
        dataCenter,
        hideLogo,
        allUser,
        connName,
        useLoginUserCredential,
        currentUser,
        authenticatedUserMap,
        defaultAuthenticator,
        view,
        pageSize,
      } = extensionData;
      // extensionRole
      setPageSize((prev) => pageSize);
      setView((prev) => views?.find((item) => item?.value === view));
      setAuthenticatedUserMap((prev) => authenticatedUserMap);
      setUsers((prev) => allUser);
      setCurrentUser((prev) => currentUser);
      setUseLoginUserCredential((prev) => useLoginUserCredential);

      setDefaultAuthenticator((prev) => defaultAuthenticator);
      widState.defaultAuthenticator = defaultAuthenticator;

      setConnName((prev) => connName);
      widState.connName = connName;

      setHideLogo((prev) => hideLogo);
      widState.hideLogo = hideLogo;

      setOrgId((prev) => orgId);
      widState.orgId = orgId;

      setApiKey((prev) => apiKey);
      widState.apiKey = apiKey;

      setDataCenterUrl((prev) => dataCenterUrl);
      widState.dataCenterUrl = dataCenterUrl;

      setDataCenter((prev) => dataCenter);
      widState.dataCenter = dataCenter;

      setZuid((prev) => zuid);
      widState.zuid = zuid;

      setZApiKey((prev) => zApiKey);
      widState.zapikey = zApiKey;

      setServiceApiKey((prev) => serviceApiKey);
      setZohoLoaded((prev) => zohoLoaded);
      if (zohoAuth) {
        // setTabIndex((prev) => 1);
        setAuth((prev) => true);
        if (
          currentUser?.email === defaultAuthenticator ||
          currentUser?.extensionRole === "Admin"
        ) {
          setTabIndex((prev) => 1);
        }
      }
      setLoading((prev) => false);
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!orgId || !apiKey || !dataCenterUrl || !connName) {
    return <ShowError />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="basic tabs example"
        >
          <Tab label="Authentication" {...a11yProps(0)} />
          <Tab label="Module Setting" {...a11yProps(1)} disabled={!auth} />
          <Tab
            label="Related List Setting"
            {...a11yProps(2)}
            disabled={!auth}
          />
        </Tabs>
      </Box>

      <Authentication
        auth={auth}
        tabIndex={tabIndex}
        index={0}
        setAuth={setAuth}
        orgId={orgId}
        apiKey={apiKey}
        dataCenterUrl={dataCenterUrl}
        dataCenter={dataCenter}
        connName={connName}
        setTabIndex={setTabIndex}
        zApiKey={zApiKey}
        serviceApiKey={serviceApiKey}
        zuid={zuid}
        setZuid={setZuid}
        setServiceApiKey={setServiceApiKey}
        users={users}
        currentUser={currentUser}
        useLoginUserCredential={useLoginUserCredential}
        setUseLoginUserCredential={setUseLoginUserCredential}
        defaultAuthenticator={defaultAuthenticator}
        authenticatedUserMap={authenticatedUserMap}
        setAuthenticatedUserMap={setAuthenticatedUserMap}
        setSnack={setSnack}
      />

      <ModuleDefaultSetting
        tabIndex={tabIndex}
        index={1}
        orgid={orgId}
        connname={connName}
        apikey={apiKey}
        zapikey={zApiKey}
        datacenterurl={dataCenterUrl}
        zuid={zuid}
        setSnack={setSnack}
      />

      <ModulesRelatedFieldSetting
        tabIndex={tabIndex}
        index={2}
        orgid={orgId}
        connname={connName}
        apikey={apiKey}
        zuid={zuid}
        datacenterurl={dataCenterUrl}
        setSnack={setSnack}
        hideLogo={hideLogo}
        setHideLogo={setHideLogo}
        view={view}
        setView={setView}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />

      {!hideLogo ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mr: 2,
            my: 2,
            // position: "fixed",
            // zIndex: -1,
            // right: 2,
            // bottom: 1,
          }}
        >
          <img
            src={logo}
            alt="Easy plugins logo"
            height={40}
            // style={{ marginLeft: "90px" }}
          />
        </Box>
      ) : (
        <></>
      )}

      <SnackAlert
        duration={snack?.duration}
        snackOpen={snack?.open}
        handleCloseSnack={handleCloseSnack}
        severity={snack?.severity}
        message={snack?.message}
      />
    </Box>
  );
}
